'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = LayoutMobile;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _offCanvas = require('../offCanvas');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Layout Mobile Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function LayoutMobile(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        children = props.children,
        _props$isOpen = props.isOpen,
        isOpen = _props$isOpen === undefined ? false : _props$isOpen,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({}, '' + className, className));

    return (0, _jsx3.default)(_offCanvas.OffCanvasWrapper, {
        id: id,
        className: classNames,
        isOpen: isOpen,
        position: 'left'
    }, void 0, children);
}
//# sourceMappingURL=LayoutMobile.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/layoutMobile/LayoutMobile.js
// module id = 571
// module chunks = 0